module.exports = __webpack_public_path__ + "static/008593-277a0c65831a8246fb473dca95784256.jpg";